import { generateUUID } from '@wix/form-schema';
import { useState, useEffect } from 'react';
export const useAtlas = ({ enabled, getInstance, language, locale, atlasBaseUrl })=>{
    const [atlas, setAtlas] = useState();
    const instance = getInstance();
    const [sessionToken, setSessionToken] = useState(generateUUID());
    const refreshSessionToken = ()=>setSessionToken(generateUUID());
    useEffect(()=>{
        if (!enabled) {
            return;
        }
        const initAtlas = async ()=>{
            try {
                const { createAtlasService } = await import(/* webpackChunkName: "atlas-service" */ './atlas-service');
                const atlasService = createAtlasService({
                    getInstance: ()=>instance,
                    sessionToken,
                    refreshSessionToken,
                    language,
                    locale,
                    atlasBaseUrl
                });
                setAtlas(atlasService);
            } catch (_error) {}
        };
        initAtlas();
    }, [
        enabled,
        instance,
        language,
        locale,
        sessionToken,
        atlasBaseUrl
    ]);
    return atlas;
};

//# sourceMappingURL=use-atlas.js.map